import { FancyList, PrimaryCta } from '@sleepstation/components'
import {
  CopyLink,
  CopyParagraph,
  CopyTitlePrimary,
} from '@sleepstation/components-copy'
import { defaultDarkerTheme } from '@sleepstation/themes-public-site'
import React from 'react'
import { useLoaderData } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import PortalPage from '../pages/PortalPage'
import ConstrainedCopy from '../shared/ConstrainedCopy'
import FullWidthCenteredImageHeader from '../shared/FullWidthCenteredImageHeader'
import BreakoutModuleNarrow from '../shared/breakoutModules/BreakoutModuleNarrow'
import StarscapeCallToActionBreakoutModule from '../shared/breakoutModules/StarscapeCallToActionBreakoutModule'
import PortalMailingListSignup from '../shared/portal/PortalMailingListSignup'
import PortalProductShot from '../shared/portal/PortalProductShot'
import TestimonialSimple from '../shared/testimonials/TestimonialSimple'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PortalCouldYouHaveInsomniaModule = () => {
  const data = useLoaderData()
  const {
    page: { content },
  } = data

  return (
    <PortalPage data={data} footerMargin={0} showFooter={false}>
      <ConstrainedCopy>
        <BreakoutModuleNarrow
          hasBottomBorder={false}
          hasGradient={false}
          marginV={[
            [1, 0.5],
            [2, 0.5],
          ]}
        >
          <FullWidthCenteredImageHeader {...content.hero} />
        </BreakoutModuleNarrow>
        <CopyParagraph>
          Everyone has trouble sleeping from time to time and for all sorts of
          reasons and that’s perfectly OK when it doesn’t last for days, weeks,
          months or even years on end. If you’ve been experiencing any of the
          following for more than 4 weeks, then it’s time to tackle your sleep
          problem.
        </CopyParagraph>
        <FancyList {...content.symptomList} />
        <BreakoutModuleNarrow
          hasBottomBorder
          hasTopBorder
          paddingV={[
            [2, 0.5],
            [2.5, 2],
          ]}
          marginV={[
            [2, 2],
            [3, 3],
            [4, 3],
          ]}
        >
          <ConstrainedCopy>
            <TestimonialSimple {...content.testimonial} />
            <CopyTitlePrimary>When to ask for help</CopyTitlePrimary>
            <CopyParagraph>
              You don’t need to fit the clinical definition of insomnia to be
              suffering from the effects of poor sleep. If it’s an ongoing
              problem for you, <b>you owe it to yourself to get better sleep</b>
              .
            </CopyParagraph>
            <CopyParagraph>
              Our science-backed programme can get you sleeping well within
              weeks.
            </CopyParagraph>
            <FancyList {...content.list} />
            <CopyParagraph>
              Find out more{` `}
              <CopyLink
                href={content.copy.findOutMoreLink.url}
                data-cy="more-link"
              >
                here
              </CopyLink>
              .
            </CopyParagraph>
          </ConstrainedCopy>
        </BreakoutModuleNarrow>
        <BreakoutModuleNarrow
          marginV={[
            [2, 0],
            [0, 0],
          ]}
          paddingV={[
            [0, 0],
            [1, 2],
          ]}
        >
          <PortalProductShot {...content.productShot} />
        </BreakoutModuleNarrow>
        <BreakoutModuleNarrow
          hasBottomBorder={false}
          hasGradient={false}
          marginV={[[1, 0]]}
          paddingV={[
            [1, 2],
            [2, 3],
          ]}
        >
          <PortalMailingListSignup />
        </BreakoutModuleNarrow>
        <ThemeProvider theme={defaultDarkerTheme}>
          <StarscapeCallToActionBreakoutModule showBottomBorder={false}>
            <PrimaryCta
              {...content.cta}
              forceOpenInNewWindow
              showBottomBorder={false}
            />
          </StarscapeCallToActionBreakoutModule>
        </ThemeProvider>
      </ConstrainedCopy>
    </PortalPage>
  )
}

export default PortalCouldYouHaveInsomniaModule
